module.exports = __webpack_public_path__ + "static/media/features-split-image-02.3c4b53aa.png";